var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "info-tooltip") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-tooltip",
    fillRule: "nonzero",
    fill: "#FFB132"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C14.486,10 10,14.4859394 10,19.9999394 C10,25.5139394 14.486,30 20,30 C25.514,30 30,25.5139394 30,19.9999394 C30,14.4859394 25.514,10 20,10 Z M20,28 C15.5888,28 12,24.4112 12,19.9999407 C12,15.5887407 15.5888,12 20,12 C24.4112,12 28,15.5887407 28,19.9999407 C28,24.4112 24.4112,28 20,28 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001212,23.9393939 C19.3318788,23.9393939 18.7882424,24.4829091 18.7882424,25.1509697 C18.7882424,25.8196364 19.3318788,26.3636364 20.0001212,26.3636364 C20.6683636,26.3636364 21.212,25.8196364 21.212,25.1509697 C21.212,24.4829091 20.6683636,23.9393939 20.0001212,23.9393939 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,13.6363636 C18.1610909,13.6363636 16.6650909,15.1323636 16.6650909,16.9711515 C16.6650909,17.4732121 17.0721212,17.8802424 17.5741818,17.8802424 C18.0762424,17.8802424 18.4832727,17.4732121 18.4832727,16.9711515 C18.4832727,16.1349091 19.1636364,15.4545455 20,15.4545455 C20.8363636,15.4545455 21.5167879,16.1349091 21.5167879,16.9711515 C21.5167879,17.8075152 20.8363636,18.4878788 20,18.4878788 C19.4979394,18.4878788 19.0909091,18.8949091 19.0909091,19.3969697 L19.0909091,21.2121212 C19.0909091,21.7141818 19.4979394,22.1212121 20,22.1212121 C20.5020606,22.1212121 20.9090909,21.7141818 20.9090909,21.2121212 L20.9090909,20.1791515 C22.3073939,19.782303 23.3349697,18.4949091 23.3349697,16.9712121 C23.3349697,15.1323636 21.8389091,13.6363636 20,13.6363636 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTooltip);
export default __webpack_public_path__ + "static/media/info-tooltip.ab1370d315af061de2e76323a0354d42.svg";
export { ForwardRef as ReactComponent };